import {
  Box,
  Grid,
  IconButton,
  Link,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { SubscriptionContext } from "contexts/Subscription";
import { useContext } from "react";
import { UpgradeDialogSource } from "schemas/dashboard";

import BannerWrapper from "../BannerWrapper";

const CampaignLockedBanner = () => {
  const theme = useTheme();
  const isMobileScreen = useMediaQuery(theme.breakpoints.down("md"));
  const { setUpgradeDialogSource } = useContext(SubscriptionContext);

  return (
    <BannerWrapper
      color={"#C92D0A"}
      onClick={() =>
        setUpgradeDialogSource(UpgradeDialogSource.campaigns_banner)
      }
    >
      <Grid container alignItems={"center"} justifyContent={"center"}>
        <Typography
          sx={{ fontSize: { xs: 10, md: 14, color: "white" } }}
          textAlign="center"
        >
          <Box component="i" className="fa-regular fa-warning" sx={{ mr: 1 }} />
          {isMobileScreen
            ? ""
            : "Starting from March 1st, Campaign will no longer be available for free users."}{" "}
          <Link sx={{ color: "yellow.main", textDecoration: "none" }}>
            Upgrade
          </Link>{" "}
          to retain access{" "}
          {isMobileScreen ? "to campaign after March 1st." : "."}
        </Typography>

        <IconButton sx={{ fontSize: 14 }}>
          <Box
            component="i"
            className="fa-regular fa-arrow-right"
            sx={{ color: "white" }}
          />
        </IconButton>
      </Grid>
    </BannerWrapper>
  );
};

export default CampaignLockedBanner;
